import { displayError, displayWarning } from "../../utils/messageToast";
import { displaySuccess } from "../../utils/messageToast";
import { getSkillId } from "../getSkill";
import { getTabId } from "../getTab";
import { SetupAuth } from "../../client";

export const saveForm = async (
  setLoadingButtonSave: React.Dispatch<React.SetStateAction<boolean>>,
  form: any,
  authorization: string,
  authorizationRA: string,
  setButtonPublish: React.Dispatch<React.SetStateAction<boolean>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>,
  setIdFormSaved: React.Dispatch<React.SetStateAction<string>>,
  nameForm: string,
  skillIdForm: string,
  tabIdForm: string,
  aliasFormResult: string,
  ambient: string,
  setTabName: React.Dispatch<React.SetStateAction<string>>,
  setSkillName: React.Dispatch<React.SetStateAction<string>>,
  setForm?: React.Dispatch<React.SetStateAction<any[]>>,
  payloadOld?: any,
  userId?: string,
  userName?: string | null,
  clientId?: string | null,
  clientName?: string | null,
  isInForce?: boolean,
) => {
  setLoadingButtonSave(true);

  if (nameForm === "") {
    displayWarning("Preencha o nome do formulário!");
    return;
  }

  if (skillIdForm === "") {
    displayWarning("Preencha a habilidade!");
    return;
  }

  if (tabIdForm === "") {
    displayWarning("Preencha a tabulação!");
    return;
  }

  if (aliasFormResult === "") {
    displayWarning("Preencha o alias do formulário!");
    return;
  }

  await getSkillId(skillIdForm, authorizationRA, ambient, setSkillName, isInForce);

  await getTabId(tabIdForm, authorizationRA, ambient, setTabName, isInForce, skillIdForm);

  function removeEmptyFields(elements: any): void {
    for (let i = elements.length - 1; i >= 0; i--) {
      const element = elements[i];
      if ((element.id === "" || element.name === "") && !element.isNew) {
        elements.splice(i, 1);
      } else if (element.children) {
        removeEmptyFields(element.children);
      }
    }
  }

  function cleanForm(form: any): void {
    removeEmptyFields(form.template.children);
  }

  cleanForm(form);

  try {
    const apiClient = SetupAuth(authorizationRA);
    const body =
      payloadOld !== undefined || userId !== undefined || userName !== undefined || clientId !== undefined || clientName !== undefined
        ? { form, payloadOld: payloadOld ?? null, userId: userId ?? "", userName: userName ?? null, clientId: clientId ?? null, clientName: clientName ?? null }
        : form;
    const response = await apiClient.put(
      `/update-form?ambient=${ambient}`,
      body,
      {
        maxBodyLength: Infinity,
      }
    );

    const savedId =
      response?.data?.id ??
      response?.data?.form?.id ??
      response?.data?.form?.form?.id ??
      "";
    if (!savedId) {
      throw new Error("ID do formulário não retornado ao salvar.");
    }

    setIdFormSaved(String(savedId));
    setButtonPublish(true);
    setButtonSave(false);
    setLoadingButtonSave(false);
    if (setForm) {
      const clearFlagsAndStripDeleted = (items: any[]): any[] =>
        items
          .filter((item) => !item._deleted)
          .map((item) => {
            const next = { ...item, isNew: false };
            delete next._deleted;
            if (next.children) {
              next.children = clearFlagsAndStripDeleted(next.children);
            }
            return next;
          });
      setForm((prevForm) => clearFlagsAndStripDeleted(prevForm));
    }
    displaySuccess("Formulário salvo!");
  } catch (error: any) {
    const data = error?.response?.data;
    const base: string =
      data?.error || data?.message || error?.message || "Erro ao salvar o formulário.";
    const errorsObj = data?.errors ?? (data?.responseData?.errors);
    let msg = base;
    if (errorsObj && typeof errorsObj === "object") {
      const lines = Object.values(errorsObj as Record<string, string>).join("\n");
      if (lines) msg = `${base}\n${lines}`;
    }
    displayError(msg);
    return;
  }
};
